<template>
  <div class="bodypad">
    <v-icon color="red" size="42" class="mb-4">highlight_off</v-icon>
    <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">Ocurrió un error</h6>
    <p class="text-subtitle-2 text-md-subtitle-1 font-weight-regular grey--text text--darken-1 text-center">No pudimos encontrar la {{ resource }} solicitada</p>
    <v-btn type="button" depressed color="blue darken-2" class="white--text mt-6" @click="$router.go(-1)">
      Volver atrás
    </v-btn>

  </div>
</template>
<script>
export default {
  name: "NotFound",
  props: {
    resource: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
.bodypad{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 70px);
}
</style>